import CodeweaversFinance from '../modules/finance/codeweavers-finance';
import ModelIndexVehicle from '../modules/finance/vehicle-objects/model-index-vehicle';
import analyticsTagging from '../../modules/analyticsTagging';

export default function() {
    const financeAreas = document.querySelectorAll('.trim-box-finance-area');
    if (financeAreas.length == 0)  {
        return;
    }
    // console.log('Initialising finance areas', financeAreas);
    const newFinance = new CodeweaversFinance();
    // Set the NewVehicle class we imported to be used by the CodeweaversFinance class
    // This NewVehicle class determines how the results of the CodeweaversFinance finance call are displayed on results
    newFinance.setNewVehicleClass(ModelIndexVehicle);
    newFinance.setVehicleSelector('.trim-box-finance-area');
    newFinance.setFinanceProduct(window.financeType);

    if (getCookieValue('new_finance_modified') !== 'Y') {
        newFinance.setDeposit(window.deposit);
        newFinance.setTerm(window.term);
        newFinance.setMileage(window.mileage);
    }

    newFinance.getFinance()
    .then(responses => {
        analyticsTagging('.trim-box-finance-area');
    })
}